import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { TextField } from "components/support";
import { debounce } from "util";

class Filter extends Component {
  state = {
    name: "",
    email: ""
  };

  handleField = (field, value) => {
    const { onFilter } = this.props;
    this.setState({ [field]: value }, debounce(() => onFilter(this.state)));
  };

  render() {
    const { name, email } = this.state;

    return (
      <Paper elevation={1} className="p-sm mb-md full-width">
        <Typography type="headline">Filtro</Typography>
        <Row between="xs">
          <Col xs={12} sm={6} md>
            <TextField
              allowClear
              fullWidth
              label="Nome"
              value={name}
              onChange={(_, value) => this.handleField("name", value)}
            />
          </Col>
          <Col xs={12} sm={6} md>
            <TextField
              allowClear
              fullWidth
              label="E-mail"
              value={email}
              onChange={(_, value) => this.handleField("email", value)}
            />
          </Col>
        </Row>
      </Paper>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/app/support/company/company-show/filter/index.jsx